export enum Scope {
  PROFILE = 'profile',
  EMAIL = 'email',
  OPENID = 'openid',
}
